// extracted by mini-css-extract-plugin
export default {"productDescription":"Oaa-z","featuredDescription":"Paa-z","description":"Qaa-z","more":"Raa-z","descriptionSku":"Saa-z"};